import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const UT = [
  "Logan", "Providence", "Smithfield", "Hyrum", "North Logan", "Nibley",
  "Wellsville", "Richmond", "Brigham City", "Tremonton", "Perry",
];
const ID = [
  "Preston", "Franklin", "Malad", "Downey", "Soda Springs", "Montpelier", "Georgetown",
];

export default function ServiceAreasStrip() {
  return (
    <section
      className="relative py-32 lg:py-40 px-6 lg:px-10 border-t border-[color:var(--border)]"
      data-testid="service-areas-strip"
    >
      <div className="mx-auto max-w-[1400px]">
        <div className="grid grid-cols-12 gap-6 lg:gap-10">
          <div className="col-span-12 lg:col-span-4">
            <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--blue)]">Coverage</div>
            <Reveal>
              <h2 className="mt-4 font-display font-semibold text-[clamp(2.5rem,6vw,5rem)] leading-[0.95] text-white">
                Two states.<br />
                <span className="font-editorial italic font-normal text-[color:var(--blue)]">
                  One team.
                </span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-6 text-[15px] text-[color:var(--muted)] leading-[1.75] max-w-md">
                We serve homes across Northern Utah's Cache Valley and Box Elder county, and into Southern Idaho's Franklin, Bear Lake and Oneida counties. Vanguard Water Systems is the local Kinetico dealer for every one of them.
              </p>
              <Link to="/service-areas" className="btn-ghost mt-8" data-testid="service-areas-cta">
                Full Service Map
              </Link>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
              <Reveal delay={0.1}>
                <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--muted)] mb-6">
                  Northern Utah
                </div>
                <ul className="space-y-3">
                  {UT.map((c, i) => (
                    <li key={c}>
                      <span className="font-display text-2xl lg:text-3xl font-light text-white/90 link-underline">
                        <span className="text-[color:var(--green)] mr-3 text-sm font-body">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        {c}
                      </span>
                    </li>
                  ))}
                </ul>
              </Reveal>

              <Reveal delay={0.2}>
                <div className="text-[11px] uppercase tracking-[0.35em] text-[color:var(--muted)] mb-6">
                  Southern Idaho
                </div>
                <ul className="space-y-3">
                  {ID.map((c, i) => (
                    <li key={c}>
                      <span className="font-display text-2xl lg:text-3xl font-light text-white/90 link-underline">
                        <span className="text-[color:var(--green)] mr-3 text-sm font-body">
                          {String(i + 1).padStart(2, "0")}
                        </span>
                        {c}
                      </span>
                    </li>
                  ))}
                </ul>
              </Reveal>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
